var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPriceTag2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.7,33.013,33,17.714A3.389,3.389,0,0,0,34,15.3V3.4A3.4,3.4,0,0,0,30.6,0H18.7a3.366,3.366,0,0,0-2.4.986L1,16.286A3.44,3.44,0,0,0,0,18.7a3.313,3.313,0,0,0,1,2.4L12.9,33a3.313,3.313,0,0,0,2.4,1A3.365,3.365,0,0,0,17.7,33.013ZM30.6,15.3,15.3,30.616,3.4,18.683l15.3-15.3V3.4H30.6ZM28.9,7.65a2.55,2.55,0,1,0-2.55,2.55A2.55,2.55,0,0,0,28.9,7.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriceTag2);
export default __webpack_public_path__ + "static/media/icon-price-tag2.fab639e24d095791930ed493c81826e5.svg";
export { ForwardRef as ReactComponent };